module.exports = __webpack_public_path__ + "static/media/w-2_34.721de137.png";